import setThemeMode from "./setThemeMode";
import previewMode from "./previewMode";
import openHtml from "./openHtml";
import toggleDirHtml from "./toggleDirHtml";
import resizeHtml from "./resizeHtml";
import updateHtml from "./updateHtml";
import removeId from "./removeId";
import editId from "./editId";
import editDoneId from "./editDoneId";
import saveTemplate from "./saveTemplate";
import saveTheme from "./saveTheme";
import setFailMessage from "./setFailMessage";
import setSelected from "./setSelected";
import setPrompt from "./setPrompt";
import updateCompiledTheme from "./updateCompiledTheme";
import updateNode from "./updateNode";
import updateSectionColumns from "./updateSectionColumns";
import updateTableColumns from "./updateTableColumns";
import updateTheme from "./updateTheme";
import uploadImage from "./uploadImage";
import uploadImageByURL from "./uploadImageByURL";
import uploadMap from "./uploadMap";
import versionsRedo from "./versionsRedo";
import versionsUndo from "./versionsUndo";

export default {
  setThemeMode,
  previewMode,
  toggleDirHtml,
  resizeHtml,
  openHtml,
  updateHtml,
  editId,
  editDoneId,
  removeId,
  saveTemplate,
  saveTheme,
  setFailMessage,
  setSelected,
  setPrompt,
  updateCompiledTheme,
  updateNode,
  updateSectionColumns,
  updateTableColumns,
  updateTheme,
  uploadImage,
  uploadImageByURL,
  uploadMap,
  versionsRedo,
  versionsUndo
};
